module.exports = __webpack_public_path__ + "img/placehold_horizontal.81bba07d.png";